import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=5e06194d&scoped=true&"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIcon.vue?vue&type=style&index=0&id=5e06194d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06194d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e06194d', component.options)
    } else {
      api.reload('5e06194d', component.options)
    }
    module.hot.accept("./DownloadIcon.vue?vue&type=template&id=5e06194d&scoped=true&", function () {
      api.rerender('5e06194d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasServicio/DownloadIcon.vue"
export default component.exports